import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Lookup } from '../../../../shared-components/lookup/lookup.model';

@Component({
  selector: 'app-add-assessment-tab-dialog',
  templateUrl: './add-assessment-tab-dialog.component.html'
})
export class AddAssessmentTabDialogComponent implements OnInit {
  displayTabs: Lookup[] = [];
  selectedTabs: Lookup[] = [];
  constructor(
    private dialogRef: MatDialogRef<AddAssessmentTabDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit() {
    this.displayTabs = this.data.tabs;
  }

  selectTab(tab: Lookup) {
    if (this.selectedTabs.indexOf(tab) > -1) {
      this.selectedTabs.splice(this.selectedTabs.indexOf(tab), 1);
    } else {
      this.selectedTabs.push(tab);
    }
  }

  saveClick() {
    this.dialogRef.close(this.selectedTabs);
  }

  cancelClick() {
    this.dialogRef.close();
  }

}
